import { demoteRole } from '@infuse/api/iam/role';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { useGenericDemoteRole } from './generic/useGenericDemoteRole';
import { demoteOrganisationRole } from '@infuse/api/iam/organisation';
import { demoteTenantRole } from '@infuse/api/iam/tenant';

export const useDemoteRole = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericDemoteRole({
      apiFn: demoteOrganisationRole,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericDemoteRole({
      apiFn: demoteTenantRole,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericDemoteRole({
    apiFn: demoteRole
  });
};
